// extracted by mini-css-extract-plugin
module.exports = {"case-management-duration":"styles_case-management-duration__1DUXA"};